import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-user-experience-confirmation-modal',
  templateUrl: './user-experience-confirmation-modal.component.html',
})
export class UserExperienceConfirmationModalComponent {
  constructor(private modalCtrl: ModalController) {}

  /**
   * Dismiss confirmation modal
   */
  dismiss(): void {
    this.modalCtrl.dismiss();
  }
}
